import {
  ModalPayloadType as ModalPayloadTypeTemp,
  OnShowModalType as OnShowModalTypeTemp,
} from './marketing-tile';

export { MarketingTile } from './marketing-tile';
export { HorizontalPosition, TileSize } from './types';

// To get around typescript export error
// Re-exporting a type when the '--isolatedModules' flag is provided requires using 'export type'.ts
export type OnShowModalType = OnShowModalTypeTemp;
export type ModalPayloadType = ModalPayloadTypeTemp;
